import paymentApi from '../../utils/paymentApi';

function unwrap(response, fallbackMessage) {
  const payload = response?.data;
  if (Number(payload?.code) !== 200) {
    if (Number(payload?.code) === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    throw new Error(payload?.message || fallbackMessage);
  }
  return payload?.data || {};
}

export async function getProjectTemplates(scope, params = {}) {
  const response = await paymentApi.get('/template/list', { params: { scope, ...params } });
  return unwrap(response, '模板加载失败');
}

export async function getProjectTemplateDetail(id) {
  const response = await paymentApi.get('/template/detail', { params: { id } });
  return unwrap(response, '模板预览加载失败');
}

export async function saveProjectTemplate(data) {
  const response = await paymentApi.post('/template/save', data);
  return unwrap(response, '模板保存失败');
}

export async function createProjectFromTemplate(id) {
  const response = await paymentApi.post('/template/use', { id });
  return unwrap(response, '项目创建失败');
}

export const cloneProjectFromTemplate = createProjectFromTemplate;

export async function deleteProjectTemplate(id) {
  const response = await paymentApi.post('/template/delete', { id });
  return unwrap(response, '模板删除失败');
}
